/**
 * =============================================================================
 * Project: lajt-online.pl
 * Created Date: 2017-10-10, 16:47:04
 * Author: Sebastian Drzewicki <sebastian.drzewicki@telestrada.pl>
 * =============================================================================
 * Last Modified: 2018-03-01, 16:00:57
 * Modified By: Sebastian Drzewicki
 * =============================================================================
 * Copyright (c) 2017 Telestrada
 * =============================================================================
 */
import { mapGetters } from 'vuex';

// COMPONENT ///////////////////////////////////////////////////////////////////
export default {
  name: 'MobileMenu',

  props: ['subscriber', 'menu'],

  computed: {
    ...mapGetters(['mobileMenuIsVissible']),
  },

  methods: {
    changeUrl(paramsObject) {
      paramsObject.name === 'Logout' ? this.$emit('submit-logout') : this.$emit('change-url', paramsObject);
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/Panel/TopMenu/MobileMenu/component.js